import autosize from 'autosize';

real.autosize = (function($, real) {
    'use strict';

    let helper = null;
    const autosizeInput = function() {
        var input = $(this);

        if(helper === null) {
            helper = $('<span style="white-space: pre; display: none;">').appendTo(real.dom.$body);
        }

        helper.css('font', input.css('font'));
        helper.text(input.val() || input.attr('placeholder'));

        input.width(helper.width() + 2);

        helper.text('').removeClass('form-control');
    };

    return {
        init : function(elem) {
            autosize(elem.findIncludingSelf('textarea.autosize:not(.autosize-initialized)')
                .css('resize', 'none')
                .addClass('autosize-initialized')
            );

            elem.findIncludingSelf('input.autosize:not(.autosize-initialized)')
                .addClass('autosize-initialized')
                .each(function(i, input) {
                    input = $(input);

                    // Bind autosizeInput listener.
                    input.on('input', autosizeInput);

                    // Autosize once on initialization.
                    autosizeInput.call(input);
                })
            ;
        },

        update : function(elem) {
            autosize.update(elem.findIncludingSelf('textarea.autosize.autosize-initialized'));

            elem.findIncludingSelf('input.autosize.autosize-initialized').each(function() {
                autosizeInput.call(this);
            });
        },

        destroy : function(elem) {
            autosize.destroy(elem.findIncludingSelf('textarea.autosize.autosize-initialized')
                .removeClass('autosize-initialized')
            );

            elem.findIncludingSelf('input.autosize.autosize-initialized')
                .removeClass('autosize-initialized')
                .each(function(i, input) {
                    $(input).off('input', autosizeInput);
                })
            ;
        }
    };
})(jQuery, real);
